import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DriverMedicalCertificateStatusType, IDriverMedicalCertificateStatusType } from '../../../driver/models/enums/driver-medical-certificate-status-type.enum';
import { MedicalExamCertificate } from '../../../driver/models/requirement/medical-exam-certificate.model';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { MedicalReviewService } from '../../services/medical-review.service';

@Component({
    selector: 'customer-mrp-certificate-status',
    templateUrl: './customer-mrp-certificate-status.html',
})
export class CustomerMrpCertificateStatusComponent extends BaseComponent {
    public form: UntypedFormGroup;
    public showButtonLoading: boolean;
    public disableSave = false;
    public statusEnum: DriverMedicalCertificateStatusType = new DriverMedicalCertificateStatusType();
    public certificate: MedicalExamCertificate;

    constructor(
        public dialogRef: MatDialogRef<CustomerMrpCertificateStatusComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: MedicalExamCertificate,
        private medicalReviewService: MedicalReviewService,
        formBuilder: UntypedFormBuilder,
        location: PlatformLocation
    ) {
        super();
        this.displayResults = false;
        this.certificate = this.data;
        this.form = formBuilder.group({
            certificateStatus: [null, Validators.required],
        });

        this.form.valueChanges.subscribe(() => {
            if (this.disableSave) {
                this.disableSave = false;
                this.clearValidationResults();
                this.showValidationComponent = false;
            }
        });

        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    public ngOnInit() {
        this.loadDefaultData();
        this.displayResults = true;
    }

    private loadDefaultData(): void {
        if (this.data) {
            this.form.get('certificateStatus').setValue(this.certificate.driverMedicalCertificateStatusTypeId);
        }
    }

    public cancel(): void {
        this.dialogRef.close();
    }

    public getCertificateStatuses(): IDriverMedicalCertificateStatusType[] {
        return this.statusEnum.GetActive().filter(e => e.id != this.statusEnum.Removed.id);
    }

    public save = (): void => {
        if (false == this.form.valid) {
            return;
        }

        this.certificate.driverMedicalCertificateStatusTypeId = this.form.get('certificateStatus').value;
        this.medicalReviewService.saveMedicalExamCertificate(this.certificate)
            .subscribe({
                next: () => this.dialogRef.close(true),
                error: e => this.handleValidationResult(e)
            });

        this.disableSave = true;
    };
}
